import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useMemo } from "react";
import { SearchFilterEnum } from "types/enums";

export const useFilterTranslations = () => {
    const { t } = usePaldockTranslation("tables.ui.filter");

    return useMemo(() => {
        return {
            operators: {
                [SearchFilterEnum.Like]: t("operators.like"),
                [SearchFilterEnum.NotLike]: t("operators.not_like"),
                [SearchFilterEnum.Ilike]: t("operators.ilike"),
                [SearchFilterEnum.MultiIlike]: t("operators.contains"),
                [SearchFilterEnum.NotIlike]: t("operators.not_contains"),
                [SearchFilterEnum.StartsWith]: t("operators.starts_with"),
                [SearchFilterEnum.NotStartsWith]: t("operators.not_starts_with"),
                [SearchFilterEnum.EndsWith]: t("operators.ends_with"),
                [SearchFilterEnum.NotEndsWith]: t("operators.not_ends_with"),
                [SearchFilterEnum.Equal]: t("operators.equals"),
                [SearchFilterEnum.NotEqual]: t("operators.not_equals"),
                [SearchFilterEnum.GreaterThan]: t("operators.greater_than"),
                [SearchFilterEnum.GreaterThanOrEqual]: t("operators.greater_than_or_equal"),
                [SearchFilterEnum.LessThan]: t("operators.less_than"),
                [SearchFilterEnum.LessThanOrEqual]: t("operators.less_than_or_equal"),
                [SearchFilterEnum.Between]: t("operators.between"),
                [SearchFilterEnum.NotBetween]: t("operators.not_between"),
                [SearchFilterEnum.In]: t("operators.in"),
                [SearchFilterEnum.NotIn]: t("operators.not_in"),
                [SearchFilterEnum.Empty]: t("operators.empty"),
                [SearchFilterEnum.EmptyOrNull]: t("operators.empty_or_null"),
                [SearchFilterEnum.Null]: t("operators.null"),
                [SearchFilterEnum.NotNull]: t("operators.not_null"),
            },
            entityOperators: {
                [SearchFilterEnum.In]: t("operators.in_entity"),
                [SearchFilterEnum.NotIn]: t("operators.not_in_entity"),
                [SearchFilterEnum.Null]: t("operators.null"),
                [SearchFilterEnum.NotNull]: t("operators.not_null"),
            },
            placeholders: {
                string: t("placeholders.enter_text"),
                number: t("placeholders.enter_number"),
                date: t("placeholders.select_date"),
                datetime: t("placeholders.select_datetime"),
                select: t("placeholders.select_value"),
                multiselect: t("placeholders.select_multiple"),
                boolean: t("placeholders.select_option"),
                first_field: t("placeholders.first_field"),
                second_field: t("placeholders.second_field"),
                time_period: t("placeholders.time_period"),
                rejection_reason: t("placeholders.rejection_reason"),
                excluded_weekdays: t("placeholders.excluded_weekdays"),
                url_address: t("placeholders.url_address"),
                http_method: t("placeholders.http_method"),
                expected_status: t("placeholders.expected_status"),
                timeout_ms: t("placeholders.timeout_ms"),
                percentage: t("placeholders.percentage"),
                period: t("placeholders.period"),
                count: t("placeholders.count"),
                offerSelect: t("placeholders.offerSelect"),
                partnerSelect: t("placeholders.select_value"),
                advertiserSelect: t("placeholders.select_value"),
                cascadeSelect: t("placeholders.select_value"),
                countrySelect: t("placeholders.countrySelect"),
                categorySelect: t("placeholders.categorySelect"),
                formStructureSelect: t("placeholders.select_value"),
                conversionStateSourceSelect: t("placeholders.conversionStateSourceSelect"),
                conversionStateTypeSelect: t("placeholders.conversionStateTypeSelect"),
                countryMultiSelect: t("placeholders.countryMultiSelect"),
                conversionStateSourceMultiSelect: t("placeholders.conversionStateSourceMultiSelect"),
                conversionStateTypeMultiSelect: t("placeholders.conversionStateTypeMultiSelect"),
                conversionStateStatusMultiSelect: t("placeholders.conversionStateStatusMultiSelect"),
                labelMultiSelect: t("placeholders.labelMultiSelect"),
                ratio: t("placeholders.ratio"),
                history_sent: t("placeholders.history_sent"),
                history_rejected: t("placeholders.history_rejected"),
                history_accepted: t("placeholders.history_accepted"),
                history_rejected_reason: t("placeholders.history_rejected_reason"),
                external_api: t("placeholders.external_api"),
                time_restriction: t("placeholders.time_restriction"),
                lead_count_limit: t("placeholders.lead_count_limit"),
                stepTypeSelect: t("placeholders.stepTypeSelect"),
                integrationStepTypeSelect: t("placeholders.stepTypeSelect"),
                outgoingPostbackStepTypeSelect: t("placeholders.stepTypeSelect"),
                incomingPostbackStepTypeSelect: t("placeholders.stepTypeSelect"),
                structureStepTypeSelect: t("placeholders.stepTypeSelect"),
            },
            options: {
                yes: t("options.yes"),
                no: t("options.no"),
                from: t("options.from"),
                to: t("options.to"),
            },
        };
    }, [t]);
};
